var exports = {
  "S": "NameplateBackground.module__image___RjFodV",
  "Q": "NameplateBackground.module__content___RjFodV",
};

module.exports = exports;
